<div class="overlay" *ngIf="spinnerService.get() | async">
  <div class="block-loading-spinner blockUI"> </div>
</div>